import { Component, Input, Optional, Self } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { FormGroupDirective } from '@angular/forms';
import { ControlContainer } from '@angular/forms';
import { ControlValueAccessor } from '@angular/forms';
import { NgControl } from '@angular/forms';
import { NOOP_VALUE_ACCESSOR } from '../../constants/noop-value-accessor.const';

@Component({
  selector: 'app-form-input-with-icon',
  templateUrl: './form-input-with-icon.component.html',
  styleUrls: ['./form-input-with-icon.component.scss'],
  viewProviders: [
    {
      // Serves the parent form control
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})

export class FormInputWithIconComponent {
  @Input('color') color: ThemePalette = 'primary';
  @Input('text') text: string = 'Placeholder Text';
  @Input('name') name: string;
  @Input('type') type: string;
  @Input('formControlName') formControlName: string | null;
  @Input('uppercase') uppercase: boolean = false;
  @Input('disabled') disabled: boolean = false;
  @Input('iconOutlined') iconOutlined: boolean = true;
  @Input('icon') icon: string = 'lock';
  @Input('outlined') outlined: MatFormFieldAppearance = 'outline';
  @Input('hintText') hintText: string = '';
  @Input('errorMsg') errorMsg: string = '';
  @Input('width') width: string = '328px';
  @Input('maxWidth') maxWidth: string = '100%';
  constructor(@Self() @Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = NOOP_VALUE_ACCESSOR;
    }
  }
}